export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.297 23.289">
    <g transform="translate(-47.037 0)">
      <g transform="translate(47.037 0)">
        <g transform="translate(0 0)">
          <path
            d="M63.005,3.051H60.9V2.109c0-.3-.333-.444-.638-.444H58.625A2.48,2.48,0,0,0,56.158,0,2.523,2.523,0,0,0,53.69,1.665H52.083c-.3,0-.61.139-.61.444v.943H49.366A2.356,2.356,0,0,0,47.037,5.3V21.182a2.23,2.23,0,0,0,2.329,2.107h13.64a2.23,2.23,0,0,0,2.329-2.107V5.3A2.356,2.356,0,0,0,63.005,3.051ZM52.582,2.774h1.525a.61.61,0,0,0,.527-.5,1.608,1.608,0,0,1,1.525-1.248,1.58,1.58,0,0,1,1.5,1.248.61.61,0,0,0,.554.5h1.58V4.992H52.582ZM64.225,21.182a1.125,1.125,0,0,1-1.22,1H49.366a1.125,1.125,0,0,1-1.22-1V5.3a1.247,1.247,0,0,1,1.22-1.137h2.107V5.574a.582.582,0,0,0,.61.527h8.178a.61.61,0,0,0,.638-.527V4.16h2.107A1.248,1.248,0,0,1,64.225,5.3V21.182Z"
            transform="translate(-47.037 0)"
          />
          <path
            d="M103.617,230.484a.554.554,0,0,0-.776-.028l-1.774,1.691-.749-.776a.554.554,0,0,0-.776-.028.582.582,0,0,0,0,.8l1.137,1.164a.5.5,0,0,0,.388.166.554.554,0,0,0,.388-.166l2.162-2.051a.527.527,0,0,0,.032-.744Q103.634,230.5,103.617,230.484Z"
            transform="translate(-96.603 -218.09)"
          />
          <path
            d="M205.479,256.034H199.1a.554.554,0,1,0,0,1.109h6.376a.554.554,0,1,0,0-1.109Z"
            transform="translate(-190.508 -242.448)"
          />
          <path
            d="M103.617,146.892a.554.554,0,0,0-.776-.028l-1.774,1.691-.749-.776a.554.554,0,0,0-.776-.028.582.582,0,0,0,0,.8l1.137,1.164a.5.5,0,0,0,.388.166.554.554,0,0,0,.388-.166l2.162-2.051a.527.527,0,0,0,.032-.744Q103.634,146.908,103.617,146.892Z"
            transform="translate(-96.603 -138.934)"
          />
          <path
            d="M205.479,172.442H199.1a.554.554,0,0,0,0,1.109h6.376a.554.554,0,1,0,0-1.109Z"
            transform="translate(-190.508 -163.292)"
          />
          <path
            d="M103.617,314.076a.554.554,0,0,0-.776-.028l-1.774,1.691-.749-.776a.555.555,0,0,0-.776-.028.582.582,0,0,0,0,.8l1.137,1.164a.5.5,0,0,0,.388.166.554.554,0,0,0,.388-.166l2.162-2.051a.527.527,0,0,0,.032-.744Q103.634,314.091,103.617,314.076Z"
            transform="translate(-96.603 -297.246)"
          />
          <path
            d="M205.479,339.626H199.1a.554.554,0,1,0,0,1.109h6.376a.554.554,0,1,0,0-1.109Z"
            transform="translate(-190.508 -321.605)"
          />
        </g>
      </g>
    </g>
  </svg>
);
